export const RELATIONSHIPS_NEW = 'relationships-new';
export const ENTITY_PUBLIC_PROFILE = 'entity-public-profile';
export const WALLET_SEND = 'wallet-send';
export const WALLET_TRANSFER = 'lockbox-transfer';
export const WALLET_BSV_TRANSFER = 'wallet-bsv-transfer';
export const WALLET_SELL = 'wallet-sell';
export const WALLET_BUY = 'wallet-buy';
export const WALLET_SWAP = 'wallet-swap';
export const WALLET_TOPUP = 'wallet-topup';
export const WALLET_RECEIVE = 'wallet-receive';
export const WALLET_DEPOSIT_INSTRUMENTS = 'wallet-deposit-instruments';
export const WALLET_DEPOSIT_CRYPTO = 'wallet-deposit-cryptocurrency';
export const WALLET_RECEIVE_REQUEST = 'receive-new-request';
export const WALLET_RECEIVE_REQUEST_STATUS = 'receive-request-status';
export const WALLET_RECEIVE_REQUEST_CONFIRMATION =
  'receive-request-confirmation';
export const WALLET_EXCHANGE_OFFER = 'exchange-offer';
export const WALLET_EXCHANGE_RESULT = 'exchange-result';
export const WALLET_EXCHANGE_STATUS = 'exchange-status';
export const WALLET_TRANSFER_DETAILS = 'transfer-details';
export const ACTIVITY_DETAILS = 'activity-details';
export const WALLET_LINK_ACCOUNT = 'wallet-link-account';
export const WALLET_REMOVE_ACCOUNT = 'wallet-remove-account';
export const WALLET_BANK_ACCOUNT_VERIFY = 'wallet-bank-account-verify';
export const WALLET_NEW_BANK_DEPOSIT = 'wallet-new-bank-deposit';
export const WALLET_NEW_DEPOSIT = 'wallet-new-deposit';
export const WALLET_NEW_WITHDRAWAL = 'wallet-new-withdrawal';
export const WALLET_NEW_BANK_ACCOUNT = 'wallet-new-bank-account';
export const WALLET_NEW_LOCKBOX = 'wallet-new-lockbox';
export const WALLET_DELETE_LOCKBOX = 'wallet-delete-lockbox';
export const WALLET_DEPOSIT = 'wallet-deposit';
export const ADD_NEW_PLAN = 'new-plan';

export const APP_SETTINGS = 'app-settings';
export const EDIT_PROFILE_DETAILS = 'edit-profile-details';
export const EDIT_ENTITY_HANDLE = 'edit-entity-handle';
export const EDIT_DISPLAY_NAME = 'edit-display-name';

export const GIFT_CARD_NEW = 'gift-card-new';
export const GIFT_CARD_PREVIEW = 'gift-card-preview';

// Legacy Tokenized banking
export const WALLET_NEW_BANK_WITHDRAWAL = 'wallet-new-bank-withdrawal';
export const WALLET_NEW_BANK_WITHDRAWAL_REVIEW =
  'wallet-new-bank-withdrawal-review';
export const WALLET_NEW_BANK_WITHDRAWAL_STARTED =
  'wallet-new-bank-withdrawal-started';
export const WALLET_BANK_TRANSFER_DETAILS = 'wallet-bank-transfer-details';
